var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "form-modal-v2",
      attrs: { visible: true, footer: null },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "custom-modal-content" }, [
        _c("div", { staticClass: "custom-modal-header" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.subtitle
            ? _c("div", { staticClass: "subtitle" }, [
                _vm._v(_vm._s(_vm.subtitle)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-modal-body" }, [_vm._t("body")], 2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "custom-modal-footer" },
          [_vm._t("footer")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }